import { TOKEN_SLUG } from "./constants"

export const getToken = () => {
    return localStorage.getItem(TOKEN_SLUG)
}

export const removeUserSession = () => {
    localStorage.clear()
}